// A generic type that represents any Bible Enum
export interface BibleBookProvider {
  [key: string]: string;
}

// Using Record ensures compatibility with both Enums and standard Objects
export interface BibleFieldProps<T extends Record<string, string>> {
  bibleEnum: T;
  onSelect: (value: T[keyof T]) => void;
}

export enum BibleType {
  protestant = 'protestant',
  catholic = 'catholic',
}

export function getBibleBooksCanon(type?: string | BibleType): Record<string, string> {
  if (type === BibleType.catholic) {
    return CatholicCanonBooks;
  }
  return ProtestantCanonBooks;
}

export enum ProtestantCanonBooks {
  genesis = 'Genesis',
  exodus = 'Exodus',
  leviticus = 'Leviticus',
  numbers = 'Numbers',
  deuteronomy = 'Deuteronomy',
  joshua = 'Joshua',
  judges = 'Judges',
  ruth = 'Ruth',
  first_samuel = '1 Samuel',
  second_samuel = '2 Samuel',
  first_kings = '1 Kings',
  second_kings = '2 Kings',
  first_chronicles = '1 Chronicles',
  second_chronicles = '2 Chronicles',
  ezra = 'Ezra',
  nehemiah = 'Nehemiah',
  esther = 'Esther',
  job = 'Job',
  psalms = 'Psalms',
  proverbs = 'Proverbs',
  ecclesiastes = 'Ecclesiastes',
  song_of_solomon = 'Song of Solomon (Song of Songs)',
  isaiah = 'Isaiah',
  jeremiah = 'Jeremiah',
  lamentations = 'Lamentations',
  ezekiel = 'Ezekiel',
  daniel = 'Daniel',
  hosea = 'Hosea',
  joel = 'Joel',
  amos = 'Amos',
  obadiah = 'Obadiah',
  jonah = 'Jonah',
  micah = 'Micah',
  nahum = 'Nahum',
  habakkuk = 'Habakkuk',
  zephaniah = 'Zephaniah',
  haggai = 'Haggai',
  zechariah = 'Zechariah',
  malachi = 'Malachi',
  matthew = 'Matthew',
  mark = 'Mark',
  luke = 'Luke',
  john = 'John',
  acts_of_the_apostles = 'Acts of the Apostles',
  romans = 'Romans',
  first_corinthians = '1 Corinthians',
  second_corinthians = '2 Corinthians',
  galatians = 'Galatians',
  ephesians = 'Ephesians',
  philippians = 'Philippians',
  colossians = 'Colossians',
  first_thessalonians = '1 Thessalonians',
  second_thessalonians = '2 Thessalonians',
  first_timothy = '1 Timothy',
  second_timothy = '2 Timothy',
  titus = 'Titus',
  philemon = 'Philemon',
  hebrews = 'Hebrews',
  james = 'James',
  first_peter = '1 Peter',
  second_peter = '2 Peter',
  first_john = '1 John',
  second_john = '2 John',
  third_john = '3 John',
  jude = 'Jude',
  revelation = 'Revelation',
}

export enum CatholicCanonBooks {
  genesis = 'Genesis',
  exodus = 'Exodus',
  leviticus = 'Leviticus',
  numbers = 'Numbers',
  deuteronomy = 'Deuteronomy',
  joshua = 'Joshua',
  judges = 'Judges',
  ruth = 'Ruth',
  first_samuel = '1 Samuel',
  second_samuel = '2 Samuel',
  first_kings = '1 Kings',
  second_kings = '2 Kings',
  first_chronicles = '1 Chronicles',
  second_chronicles = '2 Chronicles',
  ezra = 'Ezra',
  nehemiah = 'Nehemiah',
  tobit = 'Tobit',
  judith = 'Judith',
  esther = 'Esther',
  first_maccabees = '1 Maccabees',
  second_maccabees = '2 Maccabees',
  job = 'Job',
  psalms = 'Psalms',
  proverbs = 'Proverbs',
  ecclesiastes = 'Ecclesiastes',
  song_of_songs = 'Song of Songs',
  wisdom_of_solomon = 'Wisdom of Solomon',
  sirach = 'Sirach (Ecclesiasticus)',
  isaiah = 'Isaiah',
  jeremiah = 'Jeremiah',
  lamentations = 'Lamentations',
  baruch = 'Baruch (Includes the Letter of Jeremiah)',
  ezekiel = 'Ezekiel',
  daniel = 'Daniel (Includes Catholic additions: Prayer of Azariah, Susanna, Bel and the Dragon)',
  hosea = 'Hosea',
  joel = 'Joel',
  amos = 'Amos',
  obadiah = 'Obadiah',
  jonah = 'Jonah',
  micah = 'Micah',
  nahum = 'Nahum',
  habakkuk = 'Habakkuk',
  zephaniah = 'Zephaniah',
  haggai = 'Haggai',
  zechariah = 'Zechariah',
  malachi = 'Malachi',
  matthew = 'Matthew',
  mark = 'Mark',
  luke = 'Luke',
  john = 'John',
  acts_of_the_apostles = 'Acts of the Apostles',
  romans = 'Romans',
  first_corinthians = '1 Corinthians',
  second_corinthians = '2 Corinthians',
  galatians = 'Galatians',
  ephesians = 'Ephesians',
  philippians = 'Philippians',
  colossians = 'Colossians',
  first_thessalonians = '1 Thessalonians',
  second_thessalonians = '2 Thessalonians',
  first_timothy = '1 Timothy',
  second_timothy = '2 Timothy',
  titus = 'Titus',
  philemon = 'Philemon',
  hebrews = 'Hebrews',
  james = 'James',
  first_peter = '1 Peter',
  second_peter = '2 Peter',
  first_john = '1 John',
  second_john = '2 John',
  third_john = '3 John',
  jude = 'Jude',
  revelation = 'Revelation',
}
